<template>
    <div class="block-progress">
        <span class="block-progress__title">
            Интересы <br> и развитие
        </span>
        <p class="block-progress__text">
            Примерно к трем годам ребенок переживает первый кризис. Вчерашний ангелочек превращается в агрессивного
            упрямца, который хочет все делать сам. Открывать дверь квартиры и вызывать лифт, включать и выключать воду,
            одеваться и раздеваться. Жизнь родителей в это время похожа на хождение по минному полю, когда одно неловкое
            движение может закончиться истерикой на всю улицу.
            <br>
            <br>
            К пяти годам начинается период «почему». И тогда стремительно умнеет вся семья. Ведь родителям приходится
            искать ответы на вопросы: как работает канализация, можно ли в пять лет спать не каждый день, плачут ли мухи и
            какают ли комары.
        </p>
        <div class="block-progress__slider-box">
            <ImageSlider />
            <div class="image-caption">Детские площадки PlayHub в жилых районах ПИК</div>
        </div>
        <p class="block-progress__text block-progress--text-bottom">
            В шесть лет ребенок перестает задавать вопросы в таких количествах. Отчасти потому, что большую часть
            времени занимает подготовка к школе. Он учит буквы, цифры, тренируется пересказывать и отвечать на вопросы по
            тексту. А перед первым классом переживает еще один кризис: его поведение теряет непосредственность. Ребенок
            наконец-то понимает: говорить в гостях, что его мама все равно готовит вкуснее, не обязательно.
        </p>
        <BlockParallax class="block-progress__icon-box block-progress__cube" speed="10" direction="right" transform="rotate">
            <img
                srcset="@/assets/images/icons/cube.png, @/assets/images/icons/cube@2x.png 2x"
                src="@/assets/images/icons/cube.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__lego-yellow" speed="8" direction="left" transform="rotate">
            <img
                srcset="@/assets/images/icons/lego-yellow.png, @/assets/images/icons/lego-yellow@2x.png 2x"
                src="@/assets/images/icons/lego-yellow.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__lego-green" speed="10" direction="right" transform="rotate">
            <img
                srcset="@/assets/images/icons/lego-green.png, @/assets/images/icons/lego-green@2x.png 2x"
                src="@/assets/images/icons/lego-green.png"
                class="block-progress__icon"
            >
        </BlockParallax>

        <BlockParallax class="block-progress__icon-box block-progress--icon-desktop block-progress__cube-two" speed="10" direction="left" transform="rotate">
            <img
                srcset="@/assets/images/icons/cube.png, @/assets/images/icons/cube@2x.png 2x"
                src="@/assets/images/icons/cube.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress--icon-desktop block-progress__lego-yellow-two" speed="6" direction="right" transform="rotate">
            <img
                srcset="@/assets/images/icons/lego-yellow.png, @/assets/images/icons/lego-yellow@2x.png 2x"
                src="@/assets/images/icons/lego-yellow.png"
                class="block-progress__icon"
            >
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress--icon-desktop block-progress__lego-green-two" speed="8" direction="left" transform="rotate">
            <img
                srcset="@/assets/images/icons/lego-green.png, @/assets/images/icons/lego-green@2x.png 2x"
                src="@/assets/images/icons/lego-green.png"
                class="block-progress__icon"
            >
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
import ImageSlider from './slider'

export default {
    components: {
        BlockParallax,
        ImageSlider
    }
}
</script>

<style scoped lang="stylus">
    .block-progress {
        position relative
        +layout-sm-and-up() {
            display flex
            padding 0
            flex-wrap wrap
        }
        +layout-md-and-up() {
            margin-left 8rem
        }

        &__title {
            display block
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-text
            +layout-sm-and-up() {
                text-align center
                width 100%
                padding-right 7%
                font-size 3rem
                line-height 3.5rem
            }
            +layout-md-and-up() {
                margin-top 2rem
                text-align left
                position absolute
                left 0
                padding-left 0
            }

            br {
                display none
                +layout-md-and-up() {
                    display block
                }
            }
        }

        &__img-box {
            margin 2rem -1rem 0

            +layout-sm-and-up() {
                width 100%
                margin-left 0
                margin-right 0
            }

            +layout-md-and-up() {
                width 100%
                margin 5rem 8rem 4rem 0
            }
        }

        &__slider-box {
            margin 2rem 2rem 0

            +layout-sm-and-up() {
                width 100%
                margin 2rem auto 1rem
                max-width 78rem
            }

            +layout-md-and-up() {
                width 100%
                margin 4rem 8rem 3rem 0
            }
        }

        &__img {
            width 100%
            height auto
        }

        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.7rem 0 0 0

            +layout-sm-and-up() {
                width 100%
            }

            +layout-md-and-up() {
                padding-left 25rem
                padding-right 14rem
            }
        }
        &--text-bottom {
            +layout-md-and-up() {
                padding-right 26rem
            }
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__lego-green {
            position absolute
            top 3%
            left -12%
            transform rotate(-44deg)
            width 7.6rem

            +layout-md-and-up() {
                top auto
                left -31rem
                width 15.6rem
                bottom 12rem
            }
        }

        &__lego-green-two {
            +layout-md-and-up() {
                position absolute
                top 37rem
                right -23rem
                width 13rem
                height 12rem
            }
        }

        &__lego-yellow {
            position absolute
            right -2rem
            top 35rem
            transform rotate(47deg)
            width 6rem

            +layout-md-and-up() {
                right auto
                width 15rem
                height 15rem
                top auto
                bottom 7rem
                left -1rem
            }
        }

        &__lego-yellow-two {
            +layout-md-and-up() {
                position absolute
                right -6rem
                top 52rem
                width 10rem
            }
        }

        &__cube {
            position absolute
            bottom 22rem
            left -2rem
            width 5rem
            transform rotate(59deg)
            +layout-md-and-up() {
                left -10rem
                bottom 25rem
                width 11.6rem
            }
        }

        &__cube-two {
            +layout-md-and-up() {
                position absolute
                right -6.3rem
                top 19.9rem
                width 10rem
            }
        }

        &__circle-yellow {
            width 3.4rem
            height 3.4rem
            position absolute
            top 42%
            left 0
            transform rotate(-147deg)

            +layout-md-and-up() {
                top 29rem
                left -8rem
                width 5.4rem
                height 5.4rem
            }
        }

    }
</style>
